import { render, staticRenderFns } from "./guide-question.vue?vue&type=template&id=17d7ae28&scoped=true"
import script from "./guide-question.vue?vue&type=script&lang=js"
export * from "./guide-question.vue?vue&type=script&lang=js"
import style0 from "./guide-question.vue?vue&type=style&index=0&id=17d7ae28&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d7ae28",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/AI合规前端-测试/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('17d7ae28')) {
      api.createRecord('17d7ae28', component.options)
    } else {
      api.reload('17d7ae28', component.options)
    }
    module.hot.accept("./guide-question.vue?vue&type=template&id=17d7ae28&scoped=true", function () {
      api.rerender('17d7ae28', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/taxLaw/home/chat/guide-question.vue"
export default component.exports